import React, { useEffect, useState } from "react";
import { Row, Form, Button, Checkbox, Space } from "antd";
import { FormItem } from "components";
import { useNavigate, Link } from "react-router-dom";
import { auth } from "api/endpoints";
import { authRequest } from "api";
import { App } from "context/AppContext";
import { LockOutlined, UserOutlined, LoadingOutlined } from "@ant-design/icons";
import { errorMsg, successMsg } from "utils/msg";
import { browserName } from "react-device-detect";
import AuthWrapper from "../AuthWrapper";

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { darkMode } = App();

  const login = async (username, password) => {
    setLoading(true);
    try {
      const res = await authRequest(auth.login, {
        username,
        password,
        appVersion: "1.1",
        ipAddress: "192.168.1.92",
        deviceId: "web",
        deviceName: browserName,
        deviceType: "web",
      });
      localStorage.setItem("data", JSON.stringify(res.data));
      setLoading(false);
      navigate("/");
      successMsg("Амжилттай нэвтэрлээ.");
    } catch (error) {
      setLoading(false);
      errorMsg(error?.Msg);
    }
  };

  const onFinish = async (values) => {
    if (values.remember) {
      localStorage.setItem("username", values.username);
      localStorage.setItem("remember", values.remember);
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("remember");
    }

    const { username, password } = values;

    await login(username, password);
  };

  useEffect(() => {
    const data = localStorage.getItem("data");
    if (data) {
      navigate("/");
    } else {
      form.resetFields();
      const userName = localStorage.getItem("username");
      const remember = localStorage.getItem("remember");
      if (userName && remember) {
        form.setFieldsValue({ username: userName });
      }
      form.setFieldsValue({ remember: remember });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Row className="App">
      <AuthWrapper>
        <Row
          className="login-form"
          style={{
            padding: "30px",
            backgroundColor: darkMode ? "#141414" : "#fff",
            borderRadius: "16px",
            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
          }}
        >
          <Form onFinish={onFinish} style={{ width: "300px" }} size="large" form={form}>
            {/* <Form.Item style={{ textAlign: "center" }}>
              <Image
                src={logoSrc}
                style={{ padding: "0 20px" }}
                preview={false}
              />
            </Form.Item> */}
            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                marginBottom: "20px",
              }}
            >
              Нэвтрэх
            </div>

            <FormItem
              span={24}
              name={"username"}
              placeholder="Нэвтрэх нэр"
              hasFeedback
              rules={[
                { required: true, message: "Нэвтрэх нэрээ оруулна уу!" },
                {
                  type: "email",
                  message: "Имэйлээ шалгана уу!",
                },
              ]}
              prefix={<UserOutlined />}
            />

            <FormItem
              span={24}
              name={"password"}
              itemType="password"
              placeholder="Нууц үг"
              hasFeedback
              rules={[{ required: true, message: "Нууц үгээ оруулна уу!" }]}
              prefix={<LockOutlined />}
            />

            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>Намайг сана</Checkbox>
              </Form.Item>
              <Form.Item name="password-reset">
                <Link to="/forgot-password">Нууц үг сэргээх</Link>
              </Form.Item>
            </Space>

            <Form.Item style={{ margin: "0" }}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  padding: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {loading ? <LoadingOutlined style={{ color: "#2073ab" }} /> : <div>Нэвтрэх</div>}
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </AuthWrapper>
    </Row>
  );
};

export default LoginPage;
